import { Input } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { EditSessionContext } from "../Session";
import { isLoadingAnUpdate } from "./utils";

export interface DescriptionProps {
  isHovered: boolean;
}

export const Description: React.FC<DescriptionProps> = ({ isHovered }) => {
  const { sessionState, setSessionState, loading } =
    useContext(EditSessionContext);

  const [value, setValue] = useState(sessionState.description ?? "");

  useEffect(() => {
    setValue(sessionState.description ?? "");
  }, [sessionState.description]);

  const handleBlur = () => {
    if (value !== sessionState.description) {
      setSessionState({ ...sessionState, description: value });
    }
  };

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleBlur}
      onPressEnter={handleBlur}
      disabled={isLoadingAnUpdate(loading)}
      placeholder="No description"
      style={{
        flex: 1,
        border: "1px solid",
        borderColor: isHovered ? "black" : "white",
        boxShadow: "none",
        fontWeight: 500,
        fontSize: "16px",
        background: "transparent",
        transition: "border-color 0.2s",
      }}
    />
  );
};
